import { createBrowserRouter, Navigate } from "react-router-dom";

// Layout
import { DashboardLayout, PublicRoute, RequireSuperAdmin } from "../components";

// Screens
import LoginScreen from "../screens/LoginScreen";
import DashboardScreen from "../screens/DashboardScreen";
import MallManagementScreen from "../screens/MallManagementScreen";
import MallAdminManagementScreen from "../screens/MallAdminManagementScreen";
import RestaurantManagementScreen from "../screens/RestaurantManagementScreen";
import UserManagementScreen from "../screens/UserManagementScreen";
import PromoCodeManagementScreen from "../screens/PromoCodeManagementScreen";
import SettingsScreen from "../screens/SettingsScreen";
import OrdersScreen from "../screens/OrdersScreen";
import SubscriptionsScreen from "../screens/SubscriptionsScreen";
import CategoriesScreen from "../screens/CategoriesScreen";

const router = createBrowserRouter([
  // Public Routes
  {
    path: "/login",
    element: (
      <PublicRoute>
        <LoginScreen />
      </PublicRoute>
    ),
  },

  // Protected Routes (wrapped by DashboardLayout)
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <DashboardScreen />,
      },
      {
        path: "mall-management",
        element: (
          <RequireSuperAdmin>
            <MallManagementScreen />
          </RequireSuperAdmin>
        ),
      },
      {
        path: "mall-admins",
        element: (
          <RequireSuperAdmin>
            <MallAdminManagementScreen />
          </RequireSuperAdmin>
        ),
      },
      {
        path: "orders",
        element: <OrdersScreen />,
      },
      {
        path: "restaurant-management",
        element: <RestaurantManagementScreen />,
      },
      {
        path: "subscriptions",
        element: (
          <RequireSuperAdmin>
            <SubscriptionsScreen />
          </RequireSuperAdmin>
        ),
      },
      {
        path: "categories",
        element: (
          <RequireSuperAdmin>
            <CategoriesScreen />
          </RequireSuperAdmin>
        ),
      },
      {
        path: "user-management",
        element: <UserManagementScreen />,
      },
      {
        path: "promo-code-management",
        element: <PromoCodeManagementScreen />,
      },
      {
        path: "settings",
        element: <SettingsScreen />,
      },
    ],
  },

  // Catch all - redirect to dashboard
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />,
  },
]);

export default router;
